/* jshint esnext: true */

class controlsSwipe {

	/**
	 *
	 */
	constructor( scene, pointer, swipeThreshold = 30, swipeDuration = 500 ) {

		//  The current Scene
		this.scene = scene;

		//  The Pointer we're monitoring for swipes
		this.pointer = pointer;

		//  They must move this distance on a single axis during the swipe
		this.swipeThreshold = swipeThreshold;

		//  They cannot move more than 80% in the opposite axis during the swipe
		this.swipeAxisThreshold = swipeThreshold * 0.8;

		//  The swipe must complete within this ms value, or less
		this.swipeDuration = swipeDuration;

		this.start();

	}


	/**
	 *
	 */
	start() {

		this.scene.input.on( 'pointerup', this.onUp, this );

	}


	/**
	 *
	 */
	stop() {

		this.scene.input.off( 'pointerup', this.onUp, this );

	}


	/**
	 *
	 */
	onUp( pointer ) {

		if ( pointer !== this.pointer ) {
			return;
		}

		const distanceX = pointer.getDistanceX();
		const distanceY = pointer.getDistanceY();

		const horizontal = ( distanceX > distanceY );

		// Longer than a swipe should be so quit.
		if ( pointer.getDuration() > this.swipeDuration ) {
			return;
		}

		let emission = '';

		// console.log( 'swipe onUp', distanceX, distanceY, ( distanceX > this.swipeThreshold ), ( distanceY < this.swipeAxisThreshold ) );

		//  Horizontal Swipe
		if ( horizontal ) {

			// console.log( 'horizontal', distanceX > this.swipeThreshold, distanceY < this.swipeAxisThreshold, distanceX, distanceY );
			// if ( distanceX > this.swipeThreshold && distanceY < this.swipeAxisThreshold ) {

			// If Xdistance is greater than the swipe minimum
			// AND
			// the Ydistance is less than the Y maximum
			if ( distanceX > this.swipeThreshold && distanceY < ( distanceX * 0.8 ) ) {

				if ( pointer.velocity.x < 0 ) {
					emission = 'swipeleft';
				} else {
					emission = 'swiperight';
				}

			}
		}

		//  Vertical Swipe
		if ( !horizontal ) {

			// console.log( 'vertical', distanceY > this.swipeThreshold, distanceX < this.swipeAxisThreshold, distanceX, distanceY );
			// if ( distanceY > this.swipeThreshold && distanceX < this.swipeAxisThreshold ) {

			if ( distanceY > this.swipeThreshold && distanceX < ( distanceY * 0.8 ) ) {

				if ( pointer.velocity.y < 0 ) {
					emission = 'swipeup';
				} else {
					emission = 'swipedown';
				}

			}

		}

		if ( emission ) {

			// console.log( 'swipe emission', emission );
			this.scene.input.emit( emission, this.pointer );

		}

	}

}
